export function notifyNativeAppLogout() {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage('logout');
  }
}
